<div id="catalogs-page" *ngIf="!isQueryOngoing">
  <div class="no-business-manager-title" *ngIf="!hasConnectedBusinesses()">
    {{ 'business-manager/none' | translate }}
  </div>
  <div layout="column" *ngIf="hasConnectedBusinesses()">
    <mat-list>
      <app-business-manager *ngFor="let business of connectedBusinesses" [business]="business"></app-business-manager>
    </mat-list>
  </div>
</div>
<div class="alc-spinner-wrapper" *ngIf="isQueryOngoing">
  <mat-progress-spinner diameter="50" mode="indeterminate" color="accent"></mat-progress-spinner>
</div>
